import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ValidationService } from 'src/app/shared/service/validation.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { RegulationNotesService } from 'src/app/shared/service/regulation-notes.service'
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { ItemSelect } from '../../models/item-select.model';
import { AccountService } from '../../service/account.service';
import { UtilService } from '../../service/util.service';
import { MultiSelectComponent } from '@coreui/angular-pro';
import { Router } from '@angular/router';
import { Location } from '@angular/common'; 
import nodeTypes from 'src/app/shared/data/note-type.data';
import { RegulationAutoService } from 'src/app/views/pages/regulation/auto/service/regulation-auto.service';

@Component({
  selector: 'note-list',
  templateUrl: './note-list.component.html',
  styleUrls: ['./note-list.component.scss'],
  providers: [ RegulationNotesService ]
})
export class NoteListComponent implements OnInit{

  @Input() regulationAutoId : string = "";

  @Input() noteType : string = "";

  @ViewChild('users') userMulti:  MultiSelectComponent | undefined;

  public noteList: any = [];
  public accountList  : Array<ItemSelect> = [];
  public loading : boolean = false;
  public showMention  : boolean = false;

  //FORM GROUP
  public form !: FormGroup;
  //FORM
  public note  !: AbstractControl;
  public users !: AbstractControl;
 
  constructor(
    private validationService       : ValidationService,
    private activeModal             : NgbActiveModal,
    private formBuilder             : FormBuilder,
    private spinnerService          : NgxSpinnerService,
    private toastr                  : ToastrService,
    private regulationNotesService  : RegulationNotesService,
    private accountService          : AccountService,
    private utilService             : UtilService,
    private router                  : Router,
    private location                : Location,
    private regulationAutoService   : RegulationAutoService
  ) {}

  ngOnInit() {
    this.onLoad();
    this.buildForm();
  }

  onLoad() {
    this.spinnerService.show();
    this.regulationNotesService.getAllNotes(this.regulationAutoId)
      .subscribe({ 
        next:async (response: any) => {
          if (response.code == 0) {
              this.noteList = response.data;
          }
          else {
            this.toastr.error("Ocorreu uma falha ao buscar notas: [" + response?.resultException?.Message + "].", "Erro");
          }
          this.spinnerService.hide();
        }, 
        error: (erro: HttpErrorResponse) => { 
          this.toastr.error("Ocorreu uma falha ao buscar notas: [" + erro?.message?.replace(environment.API_BASE_URL_REGULATION_AUTO, '') + "].", "Erro")
          this.spinnerService.hide();
        }
      });
  }

  /**
     * Montagem do formulário
     * @memberof EmailDialogComponent
     */
  buildForm(): void {    
    this.form = this.formBuilder.group({
      note  : ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(4000)])],
      users : ['', Validators.compose([])]
    });

    this.note = this.form.controls['note'];
    this.users = this.form.controls['users'];
  }

  public decline() {
    this.activeModal.close();
  }

  public onSave() {
    let dataSend = {
      "id": "00000000-0000-0000-0000-000000000000",
      "regulationautoid": this.regulationAutoId,
      "note": this.note.getRawValue(),
      "notifierAccountsIds": this.users.getRawValue(),
      "notetype": this.noteType
    }; 

    this.loading = true;
    this.regulationNotesService.save(dataSend)
      .subscribe({ 
        next:async (response: any) => {
          if (response.code == 0) {
            this.toastr.success("Sucesso ao adicionar nota.", "Sucesso");
            this.onLoad();
            this.onClean();
          }
          else {
            this.toastr.error("Ocorreu uma falha ao gravar comentário no Sinistro: [" + response?.resultException?.Message + "].", "Erro");
          }
          this.loading = false;
        }, 
        error: (erro: HttpErrorResponse) => { 
          this.toastr.error("Ocorreu uma falha ao gravar comentário no Sinistro: [" + erro?.message?.replace(environment.API_BASE_URL_REGULATION_AUTO, '') + "].", "Erro")
          this.loading = false;
        }
      });
  }

  navigateRouter(noteItem: any) {
    let element = nodeTypes.find(el => el.value == noteItem?.noteType);

    if (element &&  element?.router) {
      this.regulationAutoService.getByIdNew(noteItem?.regulationAutoID)
      .subscribe({ 
        next: (data: any) => {
          if (data.code == 0) {
            this.openRouter(noteItem?.regulationAutoID, data.data, element?.router);          
          }
          else {
            this.toastr.error("Ocorreu uma falha ao buscar o(s) Sinistro(s): [" + data?.resultException?.Message + "].", "Erro");
          }
        },
        error: (erro: HttpErrorResponse) => { 
          this.toastr.error("Ocorreu uma falha ao buscar o(s) Sinistro(s): [" + erro?.message?.replace(environment.API_BASE_URL_REGULATION_AUTO, '') + "].", "Erro");
        }
      });
    } else {
      this.toastr.info("Rota não cadastrada.", "Aviso");
    }
  }

  openRouter(id: string, item: any, router: any) {
    sessionStorage.setItem(id, JSON.stringify(item))    

    const url = this.location.prepareExternalUrl(this.router.serializeUrl(
        this.router.createUrlTree([router + id])
    ));
    window.open(url, '_blank');    
  }

  openMention() {
    this.showMention = !this.showMention;

    if (this.showMention && this.accountList?.length == 0) {
      this.spinnerService.show();
      this.accountService.getAllAccount()
      .subscribe({  
        next: (data) => { 
          this.accountList = this.utilService.getAllLabelValueSelectedValues('name', 'id', data.data, 'id', []); 
          this.spinnerService.hide();
        },  
        error: (erro: HttpErrorResponse) => {  
          this.toastr.error(erro.statusText, "Erro")
          this.spinnerService.hide();
        }
      });
    }
  }

  onClean() {
    this.form.reset();
    this.userMulti?.clearAllOptions();
  }

  /**
   * 
   */
  public dismiss() {
    this.activeModal.dismiss();
  }

  /**
   * 
   * @param {AbstractControl} control
   * @returns 
   */
  errorMessage(control: AbstractControl) {
    return this.validationService.errorMessage(control);
  }
}